<template>
    <div>
        <p class="text-small font-weight-light text-grey-darken-1 mb-3 line-height-1-75" v-html="plugin.configuration"></p>
        <v-col cols="12" md="10" lg="8" xl="7" v-if="plugin.config.length">
            <v-form @submit.prevent="$refs.form.isValid ? sendConfig() : ''" ref="form">
                <custom-fields-form v-model="form" :items="plugin.config"></custom-fields-form>
                <v-btn color="success" type="submit" :loading="loading">ثبت اطلاعات</v-btn>
            </v-form>
        </v-col>
    </div>
</template>
<script>
export default {
    props: {
        plugin: {
            required: true
        }
    },
    data() {
        return {
            form: this.plugin.values,
            loading: false,
        };
    },
    methods: {
        sendConfig() {
            this.loading = true;
            let data = {};
            this.form.forEach(el => {
                data[this.plugin.config.find(x => x.id == el.id).name] = el.value;
            });
            this.$updateSettings({ ...data, _method: 'put' }).then((res) => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    this.$system.setGlobalSettings(true);
                }
            }).finally(()=>{this.loading = false});
        }
    },
};
</script>
